<template>
  <div>
    <el-row>
      <el-col
        :span="8"
        :offset="8"
        style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)"
      >
        <el-alert :title="globalError" type="error" :closable="false" v-show="hasGlobalError"></el-alert>
        <el-form
          :model="formData"
          :rules="rules"
          ref="formData"
          label-width="120px"
          style="margin:20px"
          label-position="left"
          @submit.prevent="validateBeforeSubmit"
        >
          <el-form-item label="User Login" prop="login">
            <el-input v-model="formData.login"></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="password">
            <el-input v-model="formData.password" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="submit"
              @click="submitForm('formData')"
              v-shortkey="['enter']"
              @shortkey.native="submitForm('formData')"
            >Login</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import token from "basic-auth-token";

export default {
  name: "Login",
  data() {
    return {
      formData: {
        login: "",
        password: ""
      },
      rules: {
        login: [
          {
            required: true,
            message: "Please enter the user name",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "Please enter the password",
            trigger: "blur"
          }
        ]
      },
      globalError: ""
    };
  },
  computed: {
    hasGlobalError: function() {
      return this.globalError !== "";
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.globalError = "";
          console.info(
            `Loggin on using ${this.formData.login}, ${this.formData.password}`
          );
          this.performLogin();
        }
      });
    },
    performLogin() {
      axios
        .post(process.env.VUE_APP_API + "application-users/credentials", {
          userLogin: this.formData.login,
          userPassword: this.formData.password
        })
        .then(response => {
          // login done
          console.log("Login successfull for user ", response.data["name"]);

          window.sessionStorage.setItem(
            "token",
            `Basic ${token(this.formData.login, this.formData.password)}`
          );
          window.sessionStorage.setItem("userEid", response.data["externalId"]);

          // get the rest of the user data
          axios
            .get(`${process.env.VUE_APP_API}application-users/current`, {
              headers: {
                Authorization: window.sessionStorage.getItem("token")
              }
            })
            .then(result => {
              let isAdmin = result.data["isAdmin"];
              let name = `${result.data["firstName"]} ${
                result.data["lastName"]
              }`;

              window.sessionStorage.setItem(
                "role",
                isAdmin ? "admin" : "regular"
              );
              window.sessionStorage.setItem("name", name);

              this.$store.commit('isAdmin', isAdmin);

              this.$router.push({ name: "Home" });
            });
        })
        .catch(reason => {
          console.error("Could not perform login");
          console.error(reason);

          this.globalError = "Invalid user name or wrong password";
        });
    }
  }
};
</script>
